import * as Yup from 'yup';

export const contactDetailRules = Yup.object({
  phone_number_type: Yup.mixed(),
  alternative_phone_number_type: Yup.mixed(),
});
